export const CHAR_WIDTH = 8.56;
export const LINE_HEIGHT = 16;
